import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const mediaApi = {
  // Upload image file
  uploadImage: async (file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const token = localStorage.getItem('token') || localStorage.getItem('authToken');
      
      // Use axios directly for file upload to avoid Content-Type header issues
      const response = await axios.post(`${API_BASE_URL}/media`, formData, {
        headers: token ? {
          'Authorization': token
          // Don't set Content-Type - browser will set it automatically with boundary
        } : {},
        timeout: 30000, // 30 seconds timeout for file upload
      });
      
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default mediaApi;

